import { render, staticRenderFns } from "./showRate.vue?vue&type=template&id=2afef88a&scoped=true"
import script from "./showRate.vue?vue&type=script&lang=js"
export * from "./showRate.vue?vue&type=script&lang=js"
import style0 from "./showRate.vue?vue&type=style&index=0&id=2afef88a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afef88a",
  null
  
)

export default component.exports